import React from "react";

// Single toggle replacing the separate "Expand All" / "Collapse All" text buttons
const ExpandCollapseToggle: React.FC<{
  expanded: boolean;
  onToggle: (next: boolean) => void;
}> = ({ expanded, onToggle }) => (
  <button
    type="button"
    onClick={() => onToggle(!expanded)}
    title={expanded ? "Collapse all" : "Expand all"}
    aria-label={expanded ? "Collapse all" : "Expand all"}
    className="flex items-center justify-center w-8 h-8 rounded-full bg-[#E6F7F5] text-[#00A89D] hover:bg-[#D2EEEB] transition-colors shrink-0"
  >
    <svg
      className={`w-4 h-4 transition-transform duration-200 ${expanded ? "rotate-180" : ""}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="5" width="16" height="14" rx="3" />
      <path d="M9 11l3 3 3-3" />
    </svg>
  </button>
);

export default ExpandCollapseToggle;
